var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMmlLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.6 38.3",
    style: {
      enableBackground: "new 0 0 228.6 38.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#28360B;}\n\t.st1{fill:#EDB600;}\n\t.st2{fill:#DCBF4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final_w_x2F__Outlined_Text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Revised_Logo"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Revised_x2C__PB_version"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,7l-4.4,11.3h-1.5L37,7v11.3h-3.4V2.6h4.7l3.8,9.8L46,2.6h4.7v15.8h-3.4V7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,2.3c4.8,0,8.2,3.4,8.2,8.2c0,4.8-3.5,8.2-8.2,8.2c-4.8,0-8.2-3.4-8.2-8.2C54.9,5.7,58.4,2.3,63.2,2.3z  M63.2,5.3c-2.9,0-4.8,2.2-4.8,5.2c0,2.9,1.9,5.2,4.8,5.2c2.9,0,4.8-2.2,4.8-5.2C68,7.5,66.1,5.3,63.2,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,7.7v10.6h-3.4V2.6h3.5l7.3,10.2V2.6h3.4v15.8h-3.2L79,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.8,2.6H106v2.9h-7.8v3.4h7.6v2.9h-7.6v3.7h7.8v2.9H94.8V2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.9,11.9l-6.1-9.3h3.8l3.9,6.3l3.9-6.3h3.8l-6,9.3v6.5h-3.4V11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,26.5l-4.4,11.3h-1.5L6.3,26.5v11.3H2.9V22h4.7l3.8,9.8l3.8-9.8H20v15.8h-3.4V26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,21.8c4.8,0,8.2,3.4,8.2,8.2c0,4.8-3.5,8.2-8.2,8.2c-4.8,0-8.2-3.4-8.2-8.2 C24.3,25.2,27.7,21.8,32.5,21.8z M32.5,24.8c-2.9,0-4.8,2.2-4.8,5.2c0,2.9,1.9,5.2,4.8,5.2s4.8-2.2,4.8-5.2 C37.3,27,35.4,24.8,32.5,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,32.2h-2.5v5.6H45V22h7.4c3.3,0,5.3,2.2,5.3,5.1c0,2.8-1.7,4.3-3.5,4.7l3.5,6h-3.9L50.8,32.2z  M51.9,24.9h-3.5v4.3h3.5c1.3,0,2.4-0.9,2.4-2.2S53.2,24.9,51.9,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,27.2v10.6h-3.4V22h3.5l7.3,10.2V22h3.4v15.8H73L65.4,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,22h3.4v15.8h-3.4V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,27.2v10.6h-3.4V22H93l7.3,10.2V22h3.4v15.8h-3.2L92.9,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,21.8c3.3,0,5.3,1.6,6.5,3.5l-2.8,1.5c-0.7-1.1-2.1-2-3.7-2c-2.9,0-4.9,2.2-4.9,5.2 c0,3,2.1,5.2,4.9,5.2c1.4,0,2.7-0.6,3.4-1.2V32h-4.2v-2.9h7.5v6c-1.6,1.8-3.9,3-6.7,3c-4.6,0-8.4-3.2-8.4-8.2 C108,24.9,111.7,21.8,116.3,21.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.2,2.3 13.9,6.3 15.2,5.7 16.5,6.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.9,3.2 10.1,7.4 11.1,6.4 12.5,6.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.3,5.9 6.9,9.7 7.5,8.5 8.8,8.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.8,10 4.6,13.1 4.8,11.7 5.9,10.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,15 3.7,17 3.3,15.6 4.1,14.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.4,15.1 26.3,14.5 27,15.7 26.7,17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.6,10 24.5,10.9 25.6,11.7 25.8,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.1,5.9 21.6,8.1 22.9,8.5 23.6,9.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.5,3.2 17.9,6.5 19.3,6.4 20.4,7.4  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,17.6C5,12,9.5,7.4,15.2,7.4S25.4,12,25.4,17.6H5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5,17.6C5,12,9.5,7.4,15.2,7.4S25.4,12,25.4,17.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.4,2h4.4v31.3h16.4v3.9h-20.8V2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.6,2h4.4v35.2h-4.4V2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.8,2h5l11.9,30.4L196.6,2h5l-14.2,35.2H182L167.8,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.5,2h23.1v3.9h-18.7v11.4h18.3v3.9h-18.3v12.2h18.7v3.9h-23.1V2z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmlLogoLight);
export default __webpack_public_path__ + "static/media/MMLLogoLight.8d6359253729bfc7660cc7ca67d992a2.svg";
export { ForwardRef as ReactComponent };